import React, { Fragment } from 'react';
import { SHIPPING_FORM_FIELDS as locale } from 'Utils/Constants';
import { required, shippingZip, usState, asyncValidateAddress } from 'Utils/FormValidation';
import { normalizeUSState } from 'Utils/FormNormalizers';
import { FormField } from 'Components/HookFormFields/FormField';

export const ShippingFormFields = ({ formFieldProps }) => (
  <Fragment>
    <div className="flexSplit2">
      <FormField
        name={locale.firstName.name}
        label={locale.firstName.label}
        component="InputField"
        validate={[required]}
        {...formFieldProps}
      />
      <FormField
        name={locale.lastName.name}
        label={locale.lastName.label}
        component="InputField"
        validate={[required]}
        {...formFieldProps}
      />
    </div>
    <div>
      <FormField
        name={locale.address1.name}
        label={locale.address1.label}
        component="InputField"
        validate={[required]}
        asyncValidate={[asyncValidateAddress]}
        autoValidate={true}
        {...formFieldProps}
        optionalSuccessMark
      />
      <FormField
        name={locale.address2.name}
        label={locale.address2.label}
        component="InputField"
        asyncValidate={[asyncValidateAddress]}
        autoValidate={true}
        {...formFieldProps}
        optionalSuccessMark
      />
      <FormField
        name={locale.city.name}
        label={locale.city.label}
        component="InputField"
        validate={[required]}
        {...formFieldProps}
        optionalSuccessMark
      />
      <div className="flexSplit2">
        <FormField
          name={locale.state.name}
          label={locale.state.label}
          component="InputField"
          validate={[required, usState]}
          {...formFieldProps}
          normalize={normalizeUSState}
          optionalSuccessMark
        />
        <FormField
          name={locale.zipCode.name}
          label={locale.zipCode.label}
          component="InputField"
          validate={[required, shippingZip]}
          {...formFieldProps}
          optionalSuccessMark
          type={'tel'}
        />
      </div>
    </div>
  </Fragment>
);
